document.addEventListener('DOMContentLoaded', function () {
  // Accordion Functionality
  setTimeout(() => {
    document.querySelectorAll('.asc-camp-accordion').forEach((accordion) => {
      const accordionHead = accordion.querySelector('.asc-camp-accordion-head');

      accordionHead.addEventListener('click', () => {
        accordion.classList.toggle('active');
      });
    });
  }, 1000);

  // Checkout CTA
  const checkoutCTAs = document.querySelectorAll('.asc-cart-checkout-button');

  checkoutCTAs.forEach((checkoutCTA) => {
    checkoutCTA.addEventListener('click', () => {
      const originalCheckout = document.getElementById('checkout');
      originalCheckout.click();
    });
  });

  // Sticky CTA
  const stickyCTA = document.querySelector('.asc-sticky-cta--wrapper');

  if (!stickyCTA) {
    return;
  }

  const checkoutBlock = document.querySelector('.asc-cart-checkout');

  if (!checkoutBlock) {
    return;
  }

  const checkoutBlockEnd = checkoutBlock.getBoundingClientRect().bottom;

  stickyCTA.classList.toggle('visible', checkoutBlockEnd < 0);

  window.addEventListener('scroll', () => {
    // Trigger once the checkout block has been scrolled past using window scroll position
    const checkoutBlockEnd = checkoutBlock.getBoundingClientRect().bottom;

    stickyCTA.classList.toggle('visible', checkoutBlockEnd < 0);
  });

  // FAQs
  const faqs = document.querySelector('.asc-cart-faqs');

  const mobileFaqs = faqs.cloneNode(true);

  mobileFaqs.classList.add('asc-cart-faqs-mobile');

  document.querySelector('#MainContent')?.appendChild(mobileFaqs);

  // Accordion Functionality
  document.querySelectorAll('.asc-cart-faqs-accordion').forEach((accordion) => {
    const accordionHead = accordion.querySelector(
      '.asc-cart-faqs-accordion-head',
    );

    accordionHead.addEventListener('click', () => {
      accordion.classList.toggle('active');
    });
  });

  // Upsell Product Add To Cart
  const upsellProductATCButtons = document.querySelectorAll(
    '.asc-cart-upsell-product-button',
  );

  upsellProductATCButtons.forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.classList.contains('loading')) {
        return;
      }

      button.classList.add('loading');
      const upsellProductId = button.getAttribute('data-upsell-product-id');

      const formData = {
        items: [
          {
            id: upsellProductId,
            quantity: 1,
          },
        ],
      };

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        button.classList.remove('loading');
        window.location.reload();
      } catch (error) {
        alert('Something went wrong. Please try again later.');
        console.log(error);

        button.classList.remove('loading');
      }
    });
  });
});
